module.exports = "<img src=\"/static/assets/loader.svg\" />\n"